import React from 'react';
import { Feedback, ModalContainer } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import { useDownloadXlsx } from './ButtonUploadXLSX.hooks';
import { ReactComponent as HappyFaceSvg } from 'App/assets/img/happy-face.svg';
import { ReactComponent as SadFaceSvg } from 'App/assets/img/sad-face.svg';

import { ContentModal, ContainerButton } from './ButtonUploadXSLS.styles';

export const ButtonUploadXLSX = () => {
	const {
		isLoadingXlsx,
		handleDownloadCsv,
		translate,
		feedbackModal,
		handleCloseModalFeedback,
		fetchCsv,
	} = useDownloadXlsx();

	const IconModal =
		feedbackModal.type === 'success' ? HappyFaceSvg : SadFaceSvg;

	return (
		<>
			<ModalContainer
				onClose={handleCloseModalFeedback}
				visible={feedbackModal.open}
				height="fit-content"
				zIndex={9999}
			>
				<ContentModal>
					<Feedback
						message={feedbackModal.message}
						Icon={IconModal}
						removeContainerIcon
					/>
					{feedbackModal.type === 'error' && (
						<ContainerButton>
							<Button onClick={handleCloseModalFeedback} variant="outline">
								{translate('commons.cancel')}
							</Button>
							<Button
								onClick={() => {
									fetchCsv();
									handleCloseModalFeedback();
								}}
							>
								{translate('commons.xlsx.buttonText')}
							</Button>
						</ContainerButton>
					)}
				</ContentModal>
			</ModalContainer>
			<Button loading={isLoadingXlsx} onClick={handleDownloadCsv} width="240px">
				{translate('commons.xlsx.buttonText')}
			</Button>
		</>
	);
};
